import React from 'react';

const NegotiateMessage = ({ Message }) => {

    return (
        <div className='bg-[#FEF8EE] flex flex-col gap-2 rounded-xl py-4 px-4 w-fit max-w-sm'>
            <h2 className='text-xl font-semibold'>Accepted Negotiate delivery</h2>
            <div className="bg-white border-[#E9E9E9] border-2 rounded-xl p-2 overflow-y-auto">
                <p className={'min-h-24'}>{Message}</p>
            </div>
        </div>
    );
};

export default NegotiateMessage;
